var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-overlay-popup": "" } },
    [
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("dismiss")
            }
          }
        },
        [_vm._v("❌")]
      ),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }